import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { mfaPhoneNumberUrl, phoneUpdateOtpUrl, validateOtpUrl } from './constants/urls';
import { Observable } from 'rxjs';
import {
  phoneUpdateOtpResponse,
  rawUserMfaNumber,
  VerifyOtpRequest,
  VerifyOtpResponse,
} from '../models/user-context.interface';
import { SpAuthService } from './utility-services/auth.service';
import { SpAuthMfaService } from './utility-services';

@Injectable({ providedIn: 'root' })
export class PhoneNumberUpdateService {
  constructor(
    private http: HttpClient,
    private auth: SpAuthService,
    private authMfa: SpAuthMfaService
  ) {}
  //OobCode is needed to be sent back for Otp validation
  oobCode = '';
  //Storing the Old/Current Mfa number here in the Service. TODO : Might need to store it in the component.
  currentMfaPhoneNumber = '';
  // Need to save this. Will be needed as a param if sending a delete MFA req.
  authenticatorId = '';

  getMFAPhoneNumber(): Observable<rawUserMfaNumber> {
    //1. Build URL string
    const url = `${mfaPhoneNumberUrl}`;

    //2. Fetch URL string and create Observable with Data.
    const mfaNumber$ = this.http.get<rawUserMfaNumber>(url);
    mfaNumber$.subscribe({
      next: response => {
        console.log('Retrieved Mfa number successfully', response);
        this.currentMfaPhoneNumber = response.PhoneNumber;
        this.authenticatorId = response.AuthenticatorId;
      },
      error: err => {
        console.log('Mfa number retrieval failed with message ', err);
      },
    });
    return mfaNumber$;
  }

  public sendOtpToNewPhoneNumber(newPhoneNumber: string, channel: string) {
    //Step 1: Get the Mfa Access token. TTL for this is 10 mins, so grab only when you need it.
    this.auth.RetrieveMfaAccessToken();

    this.authMfa.mfaAccessTokenSilently$.subscribe(mfaAccessToken => {
      let currentPhoneNo = this.currentMfaPhoneNumber;
      if (currentPhoneNo?.length > 10) {
        currentPhoneNo = currentPhoneNo.replace('+1', '');
      }
      console.log('CurrentPhoneno = ', currentPhoneNo);
      console.log('newPhoneNumber = ', newPhoneNumber);
      if (currentPhoneNo != newPhoneNumber && !this.authMfa.tokenExpired(mfaAccessToken)) {
        //Step 2: Call Auth0 to send Otp code to this new phone number of EE.
        const url = `${phoneUpdateOtpUrl}/${newPhoneNumber}/${channel}`;

        return this.http.get<phoneUpdateOtpResponse>(url).subscribe({
          next: response => {
            if (response.Success) {
              console.log('Otp was sent successfully to new phone', response);
              this.oobCode = response.OobCode;
            }
            // Http operation was successful but there was an error
            else {
              console.log(
                'Http operation was successfull, but Service failed to send Otp to phone number:',
                response.ErrorMessage
              );
            }
          },
          error: err => {
            console.log('Send Otp to new number failed ', err);
          },
        });
      }
    });
  }

  public validateOtp(
    newPhoneNumber: string,
    channel: string,
    otpCode: string
  ): Observable<VerifyOtpResponse> {
    //Step 1: Get the Mfa Access token. TTL for this is 10 mins, so grab only when you need it.
    this.auth.RetrieveMfaAccessToken();

    //Step 2: Call Auth0 to send Otp code to this new phone number of EE.
    const url = `${validateOtpUrl}`;

    const request: VerifyOtpRequest = {
      NewPhoneNumber: newPhoneNumber,
      OobCode: this.oobCode,
      Channel: channel,
      BindingCode: otpCode,
      OldPhoneNumber: this.currentMfaPhoneNumber,
      AuthenticatorId: this.authenticatorId,
    };

    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(request);
    return this.http.post<VerifyOtpResponse>(url, body, { headers: headers });
  }
}
